import * as API from "../framework/api";
import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";
import { createModulesReordering } from "./modules_reordering";

const container = document.querySelector(".js-learning-path__modules-container");
if (container) {
  initDragula(container);
}

function initDragula(container) {
  createModulesReordering(container, { onDrop: onReorderModules });
}

async function onReorderModules(_el, target) {
  const children = Array.from(target.children);

  const newOrder = children.map((child, index) => ({ module_id: child.dataset.id, position: index }));

  try {
    const data = await API.fetchJSON(p`/ajax/learning_paths/${target.dataset.learningPathId}/reorder_modules`, {
      method: "POST",
      body: { newOrder },
    });
    if (data.error || !data.success) {
      throw new Error(data.error);
    }
  } catch (_error) {
    Dialog.alert(
      getUITranslation("Erreur"),
      getUITranslation("Impossible de réorganiser les séquences. Rafraichissez la page et réessayez."),
      "error"
    );
  }
}
